import { render, staticRenderFns } from "./SubHeading.vue?vue&type=template&id=667c304d&scoped=true&"
import script from "./SubHeading.vue?vue&type=script&lang=js&"
export * from "./SubHeading.vue?vue&type=script&lang=js&"
import style0 from "./SubHeading.vue?vue&type=style&index=0&id=667c304d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "667c304d",
  null
  
)

export default component.exports